module.exports = __webpack_public_path__ + "static/media/Canada_blank_map.482fce51.svg";